import { Validators } from '@angular/forms';
import { maxScaleLengthValidator } from '@shared/forms/forms.validators';

export const COMMISSION_RATE_VALIDATORS = [Validators.required, maxScaleLengthValidator(3)];

export const DEFAULT_QTY_SCALE = 4;
